import { makeStyles } from '@material-ui/core/styles'
import { Box, Tooltip } from '@mui/material'
import infoToolTip from 'src/assets/Buy_Policy_Images/infoToolTip.svg'
import { Button } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import formatToINR from 'src/utils/commonMethods/formatToINR'
import { getUrlLastRoute } from 'src/utils/commonMethods'
import {
  ncbTooltip,
  POLICY_TYPE_ENUM,
} from 'src/utils/constants/BuyPolicyMotor'
import { getMotorInsuranceDetails } from 'src/services/buyPolicyMotorService'
import { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import LoadingModal from 'src/components/common/LoadingModal'
import { VEHICLE_TYPE } from 'src/utils/constants/BuyPolicyBike'
import { NOTIFICATION_TYPES } from 'src/utils/constants/common'
import { getTokenForQrReport } from 'src/services/individualService'
import {
  showNotificationMessage,
  updateCurrentPolicyDetailsMotor,
  updateSelectedQuoteMotor,
} from 'src/actions'
import { getBikeQuickQuotes } from 'src/services/buyPolicyBikeService'
import {
  premiumBreakUp_Provider_List,
  YES,
} from 'src/utils/constants/BuyPolicy'
import Modal from '@mui/material/Modal'
import PremiumBreakUp from 'src/components/BuyPolicy/insuranceScreens/motor/PremiumBreakUp'
import { NOTIFICATION_MSG_REPORTS } from 'src/utils/constants/CustomerReports'

const MotorPriceDetails = ({ handlePay, formMotorDetails }) => {
  const classes = useStyles()
  const urlLastRoute = getUrlLastRoute()
  const dispatch = useDispatch()
  const history = useHistory()
  const motorDetails = useSelector((state) => state?.buyPolicyMotorReducer)
  const paCoverDetails = useSelector((state) => state?.paCoverAmountReducer)
  const selectedQuote = motorDetails?.selectedQuote
  const currentPolicyDetails = motorDetails?.currentPolicyDetails
  const paCover = currentPolicyDetails?.paCover
  const [viewIncludedAddOns, setViewIncludedAddOns] = useState(false)
  const [viewOtherDetails, setViewOtherDetails] = useState(false)
  const [loading, setLoading] = useState(false)
  const [loadingQuote, setLoadingQuote] = useState(false)
  const [, setMotorQuote] = useState([])
  const [isPremiumBreakUp, setIsPremiumBreakUp] = useState(false)

  const showProceedToPay = () => {
    return urlLastRoute?.includes('terms-and-conditions') || false
  }
  const handleProceed = () => {
    const isPlanDetailsRoute = urlLastRoute?.includes('plan-details') || false

    if (isPlanDetailsRoute) {
      const vehicleType = motorDetails?.vehicleDetails?.vehicleType
      const insuranceDetailsPath =
        vehicleType === VEHICLE_TYPE?.TWO_WHEELER
          ? '/individual/dashboard/buyPolicy/bike/insuranceDetails/member-details'
          : '/individual/dashboard/buyPolicy/motor/insuranceDetails/member-details'

      history.push(insuranceDetailsPath)
    } else {
      formMotorDetails.submitForm()
    }
  }

  const handlePACover = () => {
    dispatch(
      updateCurrentPolicyDetailsMotor({
        ...currentPolicyDetails,
        paCover: !paCover,
      })
    )
  }

  const fetchToken = async () => {
    setLoading(true)
    const response = await getTokenForQrReport()
    try {
      if (response?.res?.status !== 200) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      // Success
      setLoading(false)

      const token = response?.res?.data?.access_token
      fetchMotorInsuranceDetails(token)
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message: NOTIFICATION_MSG_REPORTS?.ENCOUNTERED_ERROR_ON_TOKEN_FETCH,
        })
      )
    }
  }

  const fetchMotorInsuranceDetails = async (token) => {
    setLoadingQuote(true)
    const formData = {
      userName: motorDetails?.personalDetails?.name,
      mobile: motorDetails?.personalDetails?.mobileNumber,
      email: motorDetails?.personalDetails?.email,
      city: motorDetails?.personalDetails?.city,
      state: motorDetails?.personalDetails?.state,
      pinCode: motorDetails?.personalDetails?.pincode,
      makeId: motorDetails.vehicleDetails?.brand?.genericName,
      modelId: motorDetails?.vehicleDetails?.model?.id,
      variantId: motorDetails?.vehicleDetails?.variant?.id || '',
      fuelTypeId: motorDetails?.vehicleDetails?.fuelType?.id,
      registrationDate: motorDetails?.vehicleDetails?.regDate,
      vehicleNumber: motorDetails?.vehicleDetails?.vehicleNumber,
      previousInsuranceProvider:
        motorDetails?.previousPolicyDetails?.previousPolicyProvider
          ?.insuranceCompanyFirstName,
      previousPolicyNumber:
        motorDetails?.previousPolicyDetails?.previousPolicyNumber,
      claimsOnPreviousPolicy:
        motorDetails?.previousPolicyDetails?.existingPolicyClaim === YES,
      previousPolicyExpiryDate: motorDetails?.previousPolicyDetails?.expiryDate
        ? motorDetails?.previousPolicyDetails?.expiryDate
        : motorDetails?.previousPolicyDetails?.expiredDate,
      isVehicleRegisteredUnderCompanyName:
        motorDetails?.vehicleDetails?.isCompany,
      companyName: motorDetails?.vehicleDetails?.companyName,
      policyBusinessType: motorDetails?.currentPolicyDetails?.policyType,
      isPA: motorDetails?.currentPolicyDetails?.paCover,
      payAsYouDrive: false,
      insuredNoOfKms: null,
      previousNCB: motorDetails?.previousPolicyDetails.ncb,
      addOns: motorDetails?.currentPolicyDetails?.addOns,
      thirdPartyPolicyExpiryDate:
        motorDetails?.previousPolicyDetails?.thirdPartyExpiryDate || '',
      thirdPartyProvider:
        motorDetails?.previousPolicyDetails?.thirdPartyProviderFirstName || '',
      thirdPartyPolicyNo:
        motorDetails?.previousPolicyDetails?.thirdPartyPolicyNo || '',
      thirdPartyStartDate:
        motorDetails?.previousPolicyDetails?.thirdPartyStartDate || '',
      vehicleSearchQuery: motorDetails?.vehicleDetails?.model?.modelGenericName,
      manufacturingMonth: motorDetails.vehicleDetails?.monthOfManufacturer,
      manufacturingYear: motorDetails.vehicleDetails?.yearOfManufacturer,
      engineNo: motorDetails.vehicleDetails?.engineNumber,
      chassisNo: motorDetails.vehicleDetails?.chassisNumber,
      idv: motorDetails?.currentPolicyDetails?.idv,
      providerId: motorDetails?.selectedQuote?.providerId,
    }
    const response =
      motorDetails?.vehicleDetails?.vehicleType === VEHICLE_TYPE?.TWO_WHEELER
        ? await getBikeQuickQuotes(token, formData)
        : await getMotorInsuranceDetails(token, formData)
    try {
      if (response?.res?.status !== 200) {
        setLoadingQuote(false)

        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      // Success
      setLoadingQuote(false)
      const responseData = response?.res?.data
      if (responseData?.success) {
        setMotorQuote(responseData?.quickQuoteResponse)

        dispatch(updateSelectedQuoteMotor(responseData?.quickQuoteResponse[0]))
        if (paCover) {
          dispatch(
            updateCurrentPolicyDetailsMotor({
              ...currentPolicyDetails,
              paPremium: responseData?.quickQuoteResponse?.[0]?.paPremium,
            })
          )
        }
      } else {
        setMotorQuote(responseData?.quickQuoteResponse)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: responseData?.message,
          })
        )
      }
    } catch (err) {
      setLoadingQuote(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message:
            NOTIFICATION_MSG_REPORTS?.ENCOUNTERED_ERROR_ON_POLICY_DETAILS,
        })
      )
    }
  }

  useEffect(() => {
    fetchToken()
    if (premiumBreakUp_Provider_List?.includes(selectedQuote?.providerId)) {
      setIsPremiumBreakUp(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paCover])

  return (
    <>
      <LoadingModal loading={loading || loadingQuote} />
      <Box className={classes.PriceDetailsContainer}>
        <Box className={classes.PriceDetailsOutline}>
          <Box className={classes.PriceDetailsContainerRow}>
            <Box className={classes.PriceDetailsContainerColumn}>
              <Box>
                <img src={selectedQuote.providerImage} alt='Provider Image' />
              </Box>
              <Box className={classes.brandTagLine}>
                {selectedQuote?.providerName}
              </Box>
            </Box>
            <Box className={classes.PriceDetailsContainerColumn}>
              <Box className={classes.coverText}>
                Cover: {formatToINR(selectedQuote?.idvCover)}
              </Box>
            </Box>
          </Box>
          <Box className={classes.PriceElementsContainer}>
            <Box className={classes.PriceDetailsContainerRow}>
              <Box className={classes.PriceDetailsContainerRowHeadingStyleBold}>
                {' '}
                Base Premium
              </Box>
              <Box className={classes.PriceDetailsContainerRowDataStyleBold}>
                {formatToINR(selectedQuote?.netPremium)}
              </Box>
            </Box>
            <Box className={classes.PriceDetailsContainerRow}>
              <Box className={classes.PriceDetailsContainerRowHeadingStyle}>
                NCB
                <Tooltip
                  title={
                    <>
                      <Box>{ncbTooltip?.ncbOne}</Box>
                    </>
                  }
                >
                  <img
                    src={infoToolTip}
                    alt={infoToolTip}
                    className={classes.infoImage}
                  />
                </Tooltip>
              </Box>

              <Box className={classes.PriceDetailsContainerRowDataStyleAddOns}>
                <Box className={classes.PriceDetailsContainerRowDataStyle}>
                  {selectedQuote?.previousNCB}%
                </Box>
              </Box>
            </Box>
            {selectedQuote?.addOns?.length > 0 && (
              <Box className={classes.PriceDetailsContainerRow}>
                <Box className={classes.PriceDetailsContainerRowHeadingStyle}>
                  AddOns
                </Box>
                <Box
                  className={classes.PriceDetailsContainerRowDataStyleAddOns}
                >
                  <Box className={classes.PriceDetailsContainerRowDataStyle}>
                    {formatToINR(selectedQuote?.addOnPremium)}
                  </Box>
                  <Box
                    className={classes.includedAddOnText}
                    onClick={() => {
                      setViewIncludedAddOns(!viewIncludedAddOns)
                    }}
                  >
                    View included addons
                  </Box>
                </Box>
              </Box>
            )}
            {viewIncludedAddOns && (
              <Box className={classes.paCoverOuterDiv}>
                <Box className={classes.paCoverInnerDiv}>
                  <Box>
                    {selectedQuote?.addOns?.map((addOn) => {
                      return (
                        <Box
                          className={classes.PriceDetailsContainerRow}
                          key={addOn?.coverage}
                        >
                          <Box className={classes.addOnText}>
                            {addOn?.coverage}
                          </Box>
                          <Box className={classes.addOnText}>
                            {formatToINR(addOn?.amount)}
                          </Box>
                        </Box>
                      )
                    })}
                  </Box>
                </Box>
              </Box>
            )}
            <Box className={classes.PriceDetailsContainerRow}>
              <Box className={classes.PriceDetailsContainerRowHeadingStyle}>
                GST@18%
              </Box>
              <Box className={classes.PriceDetailsContainerRowDataStyleAddOns}>
                <Box className={classes.PriceDetailsContainerRowDataStyle}>
                  + {formatToINR(selectedQuote?.gst)}
                </Box>
              </Box>
            </Box>
            {showProceedToPay() ? (
              <Box>
                {isPremiumBreakUp ? (
                  <Box className={classes.PriceDetailsContainerRow}>
                    <Box className={classes.containerRowDataStyle}>
                      <Box
                        className={classes.includedAddOnText}
                        onClick={() => {
                          setViewOtherDetails(true)
                        }}
                      >
                        Click here to show more details.
                      </Box>
                    </Box>
                  </Box>
                ) : null}
              </Box>
            ) : null}
          </Box>
          <Box>
            <Modal
              open={viewOtherDetails}
              onClose={() => setViewOtherDetails(false)}
              className={classes.premiumBreakUpPopOver}
            >
              <PremiumBreakUp setViewOtherDetails={setViewOtherDetails} />
            </Modal>
          </Box>

          {currentPolicyDetails?.policyType ===
          POLICY_TYPE_ENUM?.OWN_DAMAGE ? null : (
            <Box className={classes.paCoverOuterDiv}>
              <Box className={classes.paCoverInnerDiv}>
                <Box className={classes.PriceDetailsContainerRow}>
                  <Box className={classes.paCoverText}>
                    Add Mandatory Owner-Driver <br />
                    Personal Accident cover of ₹15 lakh.
                    <Tooltip
                      title={
                        <>
                          <Box>
                            Based on your declaration, you&apos;ve said you
                            didn&apos;t make any claims in your last policy and
                            had a $50% NCB.
                          </Box>
                        </>
                      }
                    >
                      <img
                        src={infoToolTip}
                        alt={infoToolTip}
                        className={classes.infoImage}
                      />
                    </Tooltip>
                    <Box className={classes.paCoverText}>
                      Included in Base Premium
                    </Box>
                  </Box>
                  <Box className={classes.paPrice}>
                    <Box>
                      <img
                        src={selectedQuote.providerImage}
                        className={classes.paProvider}
                      />
                    </Box>
                    <Box className={classes.checkBoxPrice}>
                      <Box>
                        <input
                          id='paCover'
                          name='paCover'
                          value={paCover}
                          type='checkbox'
                          checked={paCover}
                          onChange={handlePACover}
                          disabled={showProceedToPay()}
                          className={classes.checkboxControl}
                        />
                      </Box>

                      <Box>
                        +
                        {paCoverDetails?.paCoverValues
                          ? paCoverDetails?.paCoverValues[
                              selectedQuote?.providerId
                            ]?.paPremium
                          : null}{' '}
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          )}
          <Box className={classes.PriceDetailsTotalOutline}>
            <Box className={classes.PriceDetailsTotalOutlineMain}>
              <Box className={classes.PriceDetailsContainerRow}>
                <Box className={classes.textBold}>Total Premium</Box>
                <Box className={classes.textBold}>
                  {formatToINR(selectedQuote?.grossTotalPremium)}
                </Box>
              </Box>
            </Box>
          </Box>

          <Box className={classes.proceedBtnContainer}>
            {showProceedToPay() ? (
              <Button
                variant='contained'
                className={classes.proceedBtn}
                type='submit'
                onClick={handlePay}
                classes={{ label: classes.proceedBtn }}
              >
                Proceed to PAY
              </Button>
            ) : (
              <Button
                variant='contained'
                className={classes.proceedBtn}
                type='submit'
                onClick={handleProceed}
                classes={{ label: classes.proceedBtn }}
              >
                Proceed
              </Button>
            )}
          </Box>
        </Box>
      </Box>
    </>
  )
}

export default MotorPriceDetails

const useStyles = makeStyles({
  PriceDetailsContainer: {
    background: 'linear-gradient( 135deg,#F4EDF5 , #FFFFFF )',
    boxShadow: '0px 4px 4px 0px #00000040',
    borderRadius: 10,
    margin: '5px 0px 5px 5px',
  },
  PriceDetailsOutline: {
    padding: 20,
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
  },

  PriceDetailsContainerRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: '6px',
  },
  PriceDetailsContainerRowPA: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: '6px',
  },
  paCoverContainer: {
    backgroundColor: '#F4DEE5',
    border: '1px',
    borderRadius: '10px',
    padding: '20px',
  },
  PriceDetailsContainerColumn: {
    display: 'flex',
    flexDirection: 'column',
  },
  PriceDetailsContainerRowHeadingStyle: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '1em',
    letterSpacing: '0em',
    color: '#000000',
  },
  PriceDetailsContainerRowHeadingStyleBold: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '1em',
    letterSpacing: '0em',
    color: '#000000',
  },
  coverText: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '1em',
    letterSpacing: '0em',
    color: '#000000',
    marginLeft: 'auto',
    paddingTop: '20px',
  },
  PriceDetailsContainerRowDataStyle: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '1.1875em',
    letterSpacing: '0em',
    color: '#000000',
  },
  PriceDetailsContainerRowDataStyleAddOns: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'right',
  },
  containerRowDataStyle: {
    display: 'flex',
    flexDirection: 'row',
    textAlign: 'right',
  },

  PriceDetailsContainerRowDataStyleBold: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '1.1875em',
    letterSpacing: '0em',
    color: '#000000',
  },
  proceedBtnContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: 10,
  },
  proceedBtn: {
    border: '1px  #EF669B ',
    borderRadius: '10px ',
    fontFamily: 'Roboto',
    fontSize: '13px',
    fontWeight: 600,
    lineHeight: '1em',
    padding: '5px 10px',
    color: '#FFFFFF !important',
    background: 'linear-gradient(0deg, #EE6196, #EE6196)',
  },
  PriceDetailsTotalOutline: {
    border: '1px solid #EF669B',
    borderRadius: '0.6em',
    background: '#FFFFFF',
  },
  paCoverOuterDiv: {
    border: '1px',
    borderRadius: '0.6em',
    backgroundColor: '#F4DEE5',
  },
  paCoverInnerDiv: {
    padding: 10,
  },
  paCoverText: { color: '#64434E', fontSize: '12px' },
  PriceElementsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 5,
  },
  brandTagLine: {
    fontFamily: 'Roboto',
    fontSize: '0.625em',
    fontWeight: 400,
    lineHeight: '0.75em',
    letterSpacing: '0em',
    color: '#666666',
  },
  PriceDetailsContainerInfinity: {
    fontFamily: 'Roboto',
    fontSize: '1.0625em',
    fontWeight: 500,
    lineHeight: '1.25em',
    letterSpacing: '0em',
    color: '#2BA6C8',
    marginBottom: '2px',
  },
  infoImage: {
    marginLeft: 5,
    marginBottom: '-5px',
    width: '17px',
  },
  textBold: {
    fontWeight: 'bold',
  },
  checkboxControl: {
    cursor: 'pointer',
    height: '15px',
    width: '15px',
  },
  checkBoxPrice: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: '-10px',
  },
  paPrice: { display: 'flex', flexDirection: 'column', marginTop: '-5px' },
  paProvider: {
    height: '30px',
    width: '30px',
    paddingLeft: '30px',
  },
  includedAddOnText: {
    fontSize: '11px !important',
    fontWeight: '500',
    textAlign: 'right !important',
    color: '#379FBB',
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  addOnText: {
    color: '#64434E',
    fontSize: '12px',
  },
  addOnsSection: {
    marginLeft: 'auto',
  },
  addOnPriceDetails: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  premiumBreakUpPopOver: {
    margin: '0 auto ',
    width: '30%',
    backgroundColor: 'white',
    marginTop: '7%',
    bottom: 'unset !important',
    maxHeight: '85%',
    overflowY: 'scroll',
  },
})
